import { useEffect, useContext } from 'react';
import { useGlobalState, useMasterData } from 'mmbclient/Common/CommonHooks';
import { GLOBAL_CONTEXT, MASTERdATA } from 'mmbclient/Common/CommonVariable'
import AuthRouting from 'mmbclient/Components/AuthRouting';
import { checkSession } from 'mmbclient/Common/CommonService';
import FastBooking from 'mmbclient/Booking/FastBooking';

const Main = () => {
    return (
        <GLOBAL_CONTEXT.Provider value={useGlobalState()}>
            <MASTERdATA.Provider value={useMasterData()}>
                <Start />
            </MASTERdATA.Provider>
        </GLOBAL_CONTEXT.Provider>
        // <FastBooking/>
    );
}

const Start = () => {

    const store = useContext(GLOBAL_CONTEXT);

    useEffect(() => {
        checkSession(store);
    }, []);

    return (
        <AuthRouting />
    );
}

export default Main
